.modalHeader {
  user-select: none;
}

.fullScreenHeader {
  background: #ffe000;
  color: #000000;
}

.headerButton {
  float: right;
}

.fieldsGrid {
  display: flex;
  flex-wrap: wrap;
}

.fieldCell {
  width: 50%;
  padding: 6px;
  box-sizing: border-box;
}

.fullWidth {
  width: 100%;
}

.roAttbsGreenButt:hover {
  background-color: rgb(195, 255, 195);
}

.roAttbsRedButt:hover {
  background-color: rgb(255, 198, 198);
}
